(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("element-ui"), require("axios"), require("vue"), require("vuex"));
	else if(typeof define === 'function' && define.amd)
		define("cb-components-common", ["element-ui", "axios", "vue", "vuex"], factory);
	else if(typeof exports === 'object')
		exports["cb-components-common"] = factory(require("element-ui"), require("axios"), require("vue"), require("vuex"));
	else
		root["cb-components-common"] = factory(root["ELEMENT"], root["axios"], root["Vue"], root["Vuex"]);
})(self, function(__WEBPACK_EXTERNAL_MODULE_element_ui__, __WEBPACK_EXTERNAL_MODULE_axios__, __WEBPACK_EXTERNAL_MODULE_vue__, __WEBPACK_EXTERNAL_MODULE_vuex__) {
return 